





























































import { Contact } from "../models/Contact";
import TextInput from "../core/Forms/TextInput.vue";
import InputField from "../core/Forms/InputField.vue";
import ContactCoordonneesRoleEdit from "./ContactCoordonnéesRoleEdit.vue";

export default {
    name: "ContactCoordonnesList",
    components: { ContactCoordonneesRoleEdit, InputField, TextInput },
    props: {
        contact: Contact,
    },
    methods: {
        deleteCoordonnees(coordonnees: Contact.Coordonnees) {
            _.remove(this.contact.coordonnees, {
                __uniqueid: coordonnees.__uniqueid,
            });
            this.$forceUpdate();
        },
        addCoordonnees() {
            this.contact.coordonnees.push(new Contact.Coordonnees({}));
        },
    },
};
